import React, { useState, useEffect } from "react";
import Select from "react-select";
import { FiEdit2 } from "react-icons/fi";
import redirectURL from "../redirectURL"

const SupplierConfigurations = () => {
  const [priorityMethod, setPriorityMethod] = useState({ label: "Manual Ranking", value: "manual" });
  const [rebalanceFreq, setRebalanceFreq] = useState({ label: "Daily", value: "daily" });

  const priorityOptions = [
    { label: "Manual Ranking", value: "manual" },
    { label: "Auto Based on Lead Time", value: "auto_lead" },
    { label: "Auto Based on Cost", value: "auto_cost" },
  ];

  const frequencyOptions = [
    { label: "Daily", value: "daily" },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
  ];

  const [plants, setPlants] = useState([]);

  useEffect(() => {
    fetchPlantMasterData();
  }, []);

  const fetchPlantMasterData = async () => {
    const response = await redirectURL.post("masters/getPlantMasterData", {})
      if (response.status === 200) {
        // Set the plants state with the fetched data
        setPlants(response.data.data || []);
      }
  }

  return (
    <div>
      {/* Heading */}
      <div className="mb-4">
        <h4 className="fw-bold">
          <span role="img" aria-label="plant">📈</span> Supplier / Plant Configurations
        </h4>
        <p className="text-muted">Configure plant priorities, capabilities, and logistics</p>
      </div>

      {/* Plant Priority Settings + Matrix */}
      <div className="row">
        {/* Left Column */}
        <div className="col-md-4">
          <div className="p-4 border rounded bg-white shadow-sm mb-3">
            <h5><strong>Plant Priority Settings</strong></h5>
            <p className="text-muted" style={{ fontSize: "13px" }}>Set preferred order sequence for plants</p>

            <label className="form-label">Priority Assignment Method</label>
            <Select
              options={priorityOptions}
              value={priorityMethod}
              onChange={setPriorityMethod}
              className="mb-3"
            />

            <label className="form-label">Rebalance Frequency</label>
            <Select
              options={frequencyOptions}
              value={rebalanceFreq}
              onChange={setRebalanceFreq}
              className="mb-3"
            />

            <button className="btn btn-outline-dark w-100">
              + Add New Plant
            </button>
          </div>
        </div>

        {/* Right Column */}
        <div className="col-md-8">
          <div className="p-4 border rounded bg-white shadow-sm">
            <h5><strong>Plant Configuration Matrix</strong></h5>
            <p className="text-muted">Configure lead times, and costs per plant</p>
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th>Plant Name</th>
                  <th>Priority</th>
                  {/* <th>Capacity</th> */}
                  <th>Lead Time (days)</th>
                  {/* <th>Cost per Dispatch</th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {plants.map((plant, i) => (
                  <tr key={i}>
                    <td>{plant.plant_name}</td>
                    <td><input type="number" className="form-control" defaultValue={plant.priority || ''} /></td>
                    {/* <td><input type="number" className="form-control" defaultValue={plant.capacity || ''} /></td> */}
                    <td><input type="number" className="form-control" defaultValue={plant.leadTime || ''} /></td>
                    {/* <td><input type="number" className="form-control" defaultValue={plant.cost || ''} /></td> */}
                    <td><FiEdit2 style={{ cursor: "pointer" }} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Capability Matrix */}
      {/* <div className="mt-4 p-4 border rounded bg-white shadow-sm">
        <h5><strong>Plant-SKU Capability Matrix</strong></h5>
        <p className="text-muted">Define which plants can supply which SKUs</p>

        <div className="text-center py-5">
          <div style={{ fontSize: "30px", color: "#adb5bd" }}>🏭</div>
          <p className="text-muted mt-2">SKU-Plant capability matrix will be displayed here</p>
          <button className="btn btn-dark">Configure Capabilities</button>
        </div>
      </div> */}
    </div>
  );
};

export default SupplierConfigurations;
